import Logger from '../lib/logger';

class BlockPricingTable extends HTMLElement {
  NAME = 'BlockPricingTable';
  /* list
  items
  labelsItem
  quantityTable */
  /* type */ /* default, procion, fabric */
  /* isSingle
  productForm
  productFormInput
  data */
  hasColors = false;

  constructor() {
    super();
    /* Logger.info(`${this.NAME} > constructor`); */
    this.list = this.querySelector('ul');
    this.labelsItem  = this.list.querySelector('li[data-labels]');
    this.items = Array.from(this.list.querySelectorAll('.pdp-table__list__item:not([data-labels]):not([data-info])')).reverse();
  }

  connectedCallback() {
    Logger.info(`${this.NAME} > connectedCallback`);
    //
    if (this.type !== 'procion') {
      if (this.isSingle) {
        this.single();
      } else {
        setTimeout(() => {
          this.multi();
        }, 0);
        
      }
    }
  }

  static get observedAttributes() {
    return ['form-id', 'is-single', 'data-type', 'json', 'has-colors', 'data-cur-color'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.NAME} > attributeChangedCallback > ${name} > ${newValue.substring(0,50)} ${newValue.length > 50 ? '...' : ''}`);
    //
    if (name === 'form-id') {
      this.productForm = document.getElementById(newValue);
    }
    //
    if (name === 'is-single') {
      this.isSingle = newValue === 'true';
    }
    //
    if (name === 'data-type') {
      this.type = newValue;
    }
    //
    if (name === 'json') {
      this.data = JSON.parse(newValue);
      console.log(this.data);
    }
    //
    if (name === 'has-colors') {
      this.hasColors = newValue === 'true';
    }
    if (name === 'data-cur-color' && this.hasColors) {
      this.items.forEach(item => {
        item.dataset.show = 'true';
        if (item.dataset.options.split(',').includes(newValue)) {
          if (!item.parentElement) this.labelsItem.insertAdjacentElement("afterend", item);
        } else if (item.parentElement) {
          item.remove();
        }
      });
    }
  }

  /* single variant product: add tiered pricing input to product form with pricingData obj as value */
  single() {
    Logger.info(`${this.NAME} > #single`);
    this.productFormInput = document.createElement('INPUT');
    this.productFormInput.type = 'hidden';
    this.productFormInput.name = 'properties[_tiered_pricing]';
    this.productFormInput.value = JSON.stringify(this.data[0].pricingData);
    this.productForm?.appendChild(this.productFormInput);
  }

  /* multi variant product: adds applicable tiered, bolt, or case pricing data to BlockQuantityTable's inputs */
  multi() {
    Logger.info(`${this.NAME} > #multi`);
    this.quantityTable = document.querySelector('block-quantity-table');
    this.variantPicker = document.querySelector('color-variant-picker') || document.querySelector('procion-variant-picker');
    //
    if (this.quantityTable) {
      const qInputs = this.quantityTable.inputs;
      /* console.log('qInputs', qInputs); */
      //
      this.data.forEach(obj => {
        qInputs.filter(input => input.dataset.options && 
          input.dataset.options.split(',').map(option => obj.optionNames.includes(option)).reduce((a,b) => !a ? a : b))
          .forEach(input => {
            if (obj.bolts && input.dataset.bolt === 'true') {
              input.dataset.boltsPricing = JSON.stringify(obj.bolts);
              const inventory = parseInt(input.dataset.inventoryQuantity);
              input.max = Math.floor(inventory  / obj.bolts.length);
              if (inventory < obj.bolts.length) input.hidden = true;
            } else if (obj.case && input.dataset.case === 'true') {
              input.dataset.casePricing = JSON.stringify(obj.case);
            } else {
              input.dataset.tieredPricing = JSON.stringify(obj.pricingData);
            }
          });
      });
    } else if (this.variantPicker) {
      const colorTableItems = Array.from(this.variantPicker.querySelectorAll('li[is="color-table-item"]'));
      this.data.forEach(obj => {
        const colorTableItem = colorTableItems.find(item => obj.optionNames.includes(item.dataset.colorOption));
        if (colorTableItem) {
          if (obj.optionNames.includes(colorTableItem.dataset.otherOption)) {
            colorTableItem.dataset.tieredPricing = JSON.stringify(obj.pricingData);
          }
        }
        const items = colorTableItem ? [colorTableItem] : colorTableItems;
        items.forEach(item => {
          const options = item.querySelectorAll('select option:not([disabled])');
          options.forEach(option => {
            const values = option.value.split('|');
            /* console.log(values[3], obj.optionNames, obj.optionNames.includes(values[3])); */
            if (obj.optionNames.includes(values[3]) && !values[4]) {
              values.push(JSON.stringify(obj.pricingData));
              option.value = values.join('|');
            }
          });
        });
      });
    }
  }

}

customElements.define('block-pricing-table', BlockPricingTable);
